import * as React from "react";
import { observer } from "mobx-react";
import { useContext, useState } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Link, RouteComponentProps } from "react-router-dom";
import { PatternEditor } from "../organisms/PatternEditor";
import {
  Form,
  Switch,
  Select,
  message,
  Spin,
  Input,
  DatePicker,
  Popconfirm,
} from "antd";
import {
  cardDesigns,
  CardDesign,
  deliverySchedules,
  isDeliverySchedule,
} from "../../stores/ContactViewStore";
import { css, SerializedStyles } from "@emotion/core";
import { Arrow } from "../atoms/ArrowLink";
import { medium, white } from "../../style/button";
// @ts-ignore
import AP01 from "../../../img/card/AP01.jpg";
// @ts-ignore
import AP02 from "../../../img/card/AP02.jpg";
// @ts-ignore
import AP03 from "../../../img/card/AP03.jpg";
// @ts-ignore
import AP04 from "../../../img/card/AP04.jpg";
// @ts-ignore
import AP05 from "../../../img/card/AP05.jpg";
// @ts-ignore
import AP06 from "../../../img/card/AP06.jpg";
// @ts-ignore
import AP07 from "../../../img/card/AP07.jpg";
// @ts-ignore
import AP08 from "../../../img/card/AP08.jpg";
import { Check } from "../atoms/Check";
import { checkContainer, horizontalScrollContainer } from "../../style/form";
import { FixedFooter } from "../atoms/FixedFooter";
import * as firebase from "firebase/app";
import "firebase/auth";
import { Footer } from "../organisms/Footer";
import { apiEndpoint } from "../../util";
import { title } from "../../style/header";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ja_JP";
// @ts-ignore
import banner from "../../../img/campaign-2023.png";
// @ts-ignore
import banner2x from "../../../img/campaign-2023@2x.png";

const fixedButtonCss = css`
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  min-width: 120px;

  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

type DesignCellProps = {
  design: CardDesign;
  style?: SerializedStyles;
};

const DesignCell = observer(({ design, style }: DesignCellProps) => {
  const store = useContext(ContactViewStoreContext);

  const src: string = (() => {
    switch (design) {
      case "AP01":
        return AP01;
      case "AP02":
        return AP02;
      case "AP03":
        return AP03;
      case "AP04":
        return AP04;
      case "AP05":
        return AP05;
      case "AP06":
        return AP06;
      case "AP07":
        return AP07;
      case "AP08":
        return AP08;
    }
  })();

  return (
    <div
      onClick={() => {
        store.cardDesign = design;
      }}
      css={css`
        ${checkContainer}
        ${style || ""}
      `}
    >
      {design === "不要" ? (
        <div
          css={css`
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 100%;
          `}
        >
          不要
        </div>
      ) : (
        <img src={src} width={200} />
      )}
      <Check checked={store.cardDesign === design} />
    </div>
  );
});

export const ApplicationOrder = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);

  const [loading, setLoading] = useState(false);

  const [cancelLoading, setCancelLoading] = useState(false);

  return (
    <div>
      {store.isOrdered && (
        <div
          css={css`
            font-size: 20px;
          `}
        >
          お客様はPOSTALをお申込み済みです。
        </div>
      )}
      <div
        css={css`
          display: flex;
          justify-content: flex-end;
        `}
      >
        <a href="http://s.selects.jp/yvOI" target="postal-order-guide-pdf">
          お申込みガイド(PDF)
        </a>
      </div>
      <h2 css={title}>お申込み・お見積</h2>
      <p
        css={css`
          font-size: 10px;
        `}
      >
        <strong>3週間前</strong>までにお申込みお願い致します。
        <br />
        <strong>2週間前</strong>
        までは「個数」の調整は問題なく可能ですので、お申込み時点では暫定個数で問題ありません。
        <br />
        <strong>最短6営業日発送</strong>
        のお急ぎプラン(無料)については、事前にご相談ください。
        <br />
        (詳しくはお申込みガイドを確認ください。)
      </p>
      <Link
        to="/application/contact"
        css={css`
          box-shadow: 0 1px 4px rgba(102, 29, 48, 0.2);
          border-radius: 20px;
          padding: 20px;
          margin-bottom: 20px;
          display: flex;
          text-align: left;
          color: #373742;
          align-items: center;
        `}
      >
        <div
          css={css`
            flex-grow: 1;
          `}
        >
          <h3>基本情報の確認</h3>
          {store.weddingDate && (
            <div>{store.weddingDate.format("YYYY/MM/DD")} 挙式</div>
          )}
          {store.groomName && <div>{store.groomName}様</div>}
          {store.brideName && <div>{store.brideName}様</div>}
          {store.phoneNumber && <div>{store.phoneNumber}</div>}
          <div>
            {store.postalCode && <span>&#12306;{store.postalCode}</span>}
            {store.address && <span> {store.address}</span>}
          </div>
        </div>
        <div
          css={css`
            width: 0;
          `}
        >
          <div
            css={css`
              margin-left: -40px;
            `}
          >
            <Arrow direction="right" />
          </div>
        </div>
      </Link>
      <div
        css={css`
          margin: 30px 0 20px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;

          @media (min-width: 768px) {
            flex-direction: row;
          }
        `}
      >
        <img
          css={css`
            max-width: 100%;

            @media (min-width: 768px) {
              width: 0;
              max-width: 443px;
              flex-grow: 1;
            }
          `}
          src={banner}
          srcSet={`${banner} 1x, ${banner2x} 2x`}
        />
        <div
          css={css`
            width: 20px;
            height: 10px;
            flex-shrink: 0;
          `}
        ></div>
        <p
          css={css`
            font-size: 12px;

            @media (min-width: 768px) {
              width: 0;
              flex-grow: 1;
            }
          `}
        >
          ※キャンペーン、クーポン等の併用不可です。キャンペーン期間中であっても、上限に達した場合、終了する場合がございます。
        </p>
      </div>
      <PatternEditor extended={true} />
      <div
        css={css`
          margin-bottom: 24px;
        `}
      >
        <h4>ゲストご自宅に直接POSTALを郵送する</h4>
        <Switch
          checked={store.directDelivery}
          onChange={(e) => {
            store.directDelivery = e;
          }}
        />
      </div>
      {store.directDelivery && (
        <React.Fragment>
          <div
            css={css`
              margin-bottom: 24px;
            `}
          >
            <Form
              labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }}
            >
              <p>発送日: 挙式日以降最短営業日発送</p>
              <Form.Item label="発送日の変更が必要">
                <Switch
                  checked={store.changeDeliveryDateToGuest}
                  onChange={(e) => {
                    store.changeDeliveryDateToGuest = e;
                  }}
                />
              </Form.Item>
              {store.changeDeliveryDateToGuest && (
                <Form.Item label="希望配送日">
                  <DatePicker
                    locale={locale}
                    disabledDate={(current) =>
                      current === undefined
                        ? false
                        : current < moment().endOf("day")
                    }
                    value={
                      store.deliveryDateToGuest === null
                        ? undefined
                        : store.deliveryDateToGuest
                    }
                    onChange={(moment) => {
                      store.deliveryDateToGuest =
                        moment === null ? undefined : moment;
                    }}
                  />
                </Form.Item>
              )}
            </Form>
            <div
              css={css`
                box-shadow: 0 1px 4px rgba(102, 29, 48, 0.2);
                border-radius: 20px;
                padding: 16px 10px;
                margin-bottom: 20px;
                margin-top: 16px;
              `}
            >
              <h3>案内カード</h3>
              <h4>デザイン</h4>
              <div
                css={css`
                  ${horizontalScrollContainer}
                  margin-left: -20px;
                  margin-right: -20px;

                  @media (min-width: 576px) {
                    margin-left: -50px;
                    margin-right: -50px;
                  }

                  @media (min-width: 768px) {
                    margin-left: 0;
                    margin-right: 0;
                  }
                `}
              >
                {cardDesigns.map((d, i) => (
                  <DesignCell
                    key={i}
                    design={d}
                    style={
                      i === 0
                        ? css`
                            margin-left: 20px;

                            @media (min-width: 576px) {
                              margin-left: 50px;
                            }

                            @media (min-width: 768px) {
                              margin-left: 0;
                            }
                          `
                        : undefined
                    }
                  />
                ))}
              </div>
              <Form
                labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }}
              >
                <Form.Item label="到着希望">
                  <Select
                    disabled={store.cardDesign === "不要"}
                    value={store.deliverySchedule}
                    onChange={(value: any) => {
                      if (!isDeliverySchedule(value)) return;
                      store.deliverySchedule = value;
                    }}
                  >
                    {deliverySchedules.map((s, i) => (
                      <Select.Option key={i} value={s}>
                        {s}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <div
                  css={css`
                    margin-left: 20px;
                  `}
                >
                  <p>ご自宅に発送させて頂きます</p>
                </div>
                <Form.Item label="自宅以外に届ける">
                  <Switch
                    checked={store.deliveryCardToNonHome}
                    onChange={(e) => {
                      store.deliveryCardToNonHome = e;
                    }}
                  />
                  {store.deliveryCardToNonHome && (
                    <Input.TextArea
                      rows={4}
                      placeholder="お届け先"
                      value={store.deliveryCardTo}
                      onChange={(e) => {
                        store.deliveryCardTo = e.target.value;
                      }}
                    />
                  )}
                </Form.Item>
              </Form>
            </div>
          </div>
        </React.Fragment>
      )}

      {!store.directDelivery && (
        <React.Fragment>
          <div
            css={css`
              margin-bottom: 24px;
            `}
          >
            <p>POSTALをご注文数分まとめて一カ所に納品させていただきます。</p>
            <h4>POSTALを自宅以外に届ける</h4>
            <Switch
              checked={store.deliveryToNonHome}
              onChange={(e) => {
                store.deliveryToNonHome = e;
              }}
            />
            {store.deliveryToNonHome && (
              <Form
                labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="お届け先"
                  value={store.deliveryToOther}
                  onChange={(e) => {
                    store.deliveryToOther = e.target.value;
                  }}
                  css={css`
                    margin-top: 12px;
                  `}
                />
              </Form>
            )}
            <Form
              labelCol={{ xs: { span: 24 }, sm: { span: 4 } }}
              wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }}
              css={css`
                margin-top: 20px;
              `}
            >
              <Form.Item label="発送日の変更が必要">
                <Switch
                  checked={store.changeArrivalDateToOther}
                  onChange={(e) => {
                    store.changeArrivalDateToOther = e;
                  }}
                />
              </Form.Item>
              {store.changeArrivalDateToOther && (
                <Form.Item label="到着希望日">
                  <DatePicker
                    locale={locale}
                    disabledDate={(current) =>
                      current === undefined
                        ? false
                        : current < moment().endOf("day")
                    }
                    value={
                      store.arrivalDateToOther === null
                        ? undefined
                        : store.arrivalDateToOther
                    }
                    onChange={(moment) => {
                      store.arrivalDateToOther =
                        moment === null ? undefined : moment;
                    }}
                  />
                </Form.Item>
              )}
            </Form>
          </div>
        </React.Fragment>
      )}

      <h4>POSTALの送付状文言をカスタマイズ</h4>
      <p>オリジナル文言の場合、弊社のロゴと弊社の住所は表示されません。</p>
      <Switch
        checked={store.customizeLetterMessage}
        onChange={(e) => {
          store.customizeLetterMessage = e;
        }}
      />
      {store.customizeLetterMessage && (
        <div>
          <h5>送付状文章</h5>
          <Input.TextArea
            css={css`
              font-size: 0.7em;
            `}
            rows={10}
            value={store.getLetterMessage}
            onChange={(e) => {
              store.letterMessage = e.target.value || "";
            }}
          />
        </div>
      )}

      <Footer />

      <FixedFooter alignRightOnSmallScreen={true}>
        <button
          css={css`
            ${medium}
            ${fixedButtonCss}
          `}
          onClick={() => {
            if (!store.hasAllInfo) {
              alert("プランと数量を入力してください");
              return;
            }

            history.push("/application/estimate");
          }}
        >
          お申込み/お見積り
        </button>
        <button
          css={css`
            ${medium}
            ${white}
            ${fixedButtonCss}
            ${store.isOrdered && "visibility:hidden;"}
          `}
          disabled={store.isOrdered || loading}
          onClick={() => {
            const currentUser = firebase.auth().currentUser;
            if (currentUser === null) return;

            setLoading(true);

            store
              .linkCredential()
              .then((_) => store.persist())
              .then((_) =>
                fetch(apiEndpoint("/postal/orders"), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(store.toRequest("draft")),
                })
              )
              .then((response) => {
                if (response.status >= 400) throw new Error("server error");
                message.success("下書き保存しました");
                setLoading(false);
              })
              .catch((e) => {
                console.log("error", e);
                alert("エラーが発生しました");
                setLoading(false);
              });
          }}
        >
          下書き保存
          {loading && <Spin size="small" />}
        </button>
        {store.internal && (
          <span>
            <a
              css={css`
                color: #90c2ec;
                text-decoration: underline;
              `}
              onClick={
                cancelLoading
                  ? undefined
                  : () => {
                      const currentUser = firebase.auth().currentUser;
                      if (currentUser === null) return;

                      setCancelLoading(true);
                      store.isOrdered = false;
                      store
                        .linkCredential()
                        .then((_) => store.persist())
                        .then((_) =>
                          fetch(apiEndpoint("/postal/orders"), {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify(store.toRequest("cancel")),
                          })
                        )
                        .then((response) => {
                          if (response.status >= 400)
                            throw new Error("server error");
                          message.success("キャンセルしました");
                          setCancelLoading(false);
                          history.push("/application/order");
                        })
                        .catch((e) => {
                          console.log("error", e);
                          alert("エラーが発生しました");
                          setCancelLoading(false);
                        });
                    }
              }
            >
              注文キャンセル(内部用)
            </a>
            {cancelLoading && <Spin size="small" />}
          </span>
        )}
      </FixedFooter>
    </div>
  );
});
